import { createClient as createSupabaseClient, type SupabaseClient } from "@supabase/supabase-js";

/**
 * 브라우저용 Supabase 클라이언트(싱글턴). 세션은 supabase-js 기본값대로 localStorage에 저장되고
 * 토큰 갱신도 알아서 한다. 서버(SSR)가 없어서 예전처럼 쿠키로 세션을 주고받을 일이 없다 —
 * 서버가 필요한 API(api/)에는 요청마다 `Authorization: Bearer <access_token>`으로 넘긴다
 * (lib/api/http.ts).
 *
 * 환경변수는 VITE_* 이름을 우선 읽고, 예전 NEXT_PUBLIC_* 이름도 받아준다(호스팅 설정 호환).
 * 접두사가 붙은 값은 브라우저에 그대로 노출되는 공개 값이다 — publishable key는 RLS가 항상
 * 켜져 있어야 안전하고, service role key는 여기에 절대 들어오면 안 된다.
 */
let client: SupabaseClient | null = null;

export function createClient(): SupabaseClient {
  if (client) return client;

  const url = import.meta.env.VITE_SUPABASE_URL ?? import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
  const key =
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? import.meta.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY;

  if (!url || !key) {
    throw new Error("Supabase 환경변수(VITE_SUPABASE_URL, VITE_SUPABASE_PUBLISHABLE_KEY)가 없습니다.");
  }

  client = createSupabaseClient(url, key, {
    // 메일 링크 인증(/auth/confirm)이 token_hash 방식이라 URL을 자동으로 읽을 필요는 없지만,
    // 기본 템플릿의 ?code= (PKCE) 링크도 받아줘야 해서 켜둔다.
    auth: { flowType: "pkce", detectSessionInUrl: true, persistSession: true, autoRefreshToken: true },
  });
  return client;
}
